import React from 'react';
import Card from '../../components/card';

export default ({ model, onChange, onSubmit, title, ...cardProps }) => (
  <Card
    {...cardProps}
    title={title}
    onSubmit={
      model.getIn(['loan', 'termsAgree'])
        ? undefined
        : () => {
            // Delay onSubmit until the change has been processed
            onChange('loan', 'termsAgree', true, () => onSubmit());
          }
    }
    complete
  />
);



// WEBPACK FOOTER //
// ./src/cards/welcome/card.js